module.exports = __webpack_public_path__ + "media/components/footer/static/logo-instagram-5e95a281315ab4ba977312019eec6e58.svg";